import type {
  IAviatorProfile,
  IAviatorProfileInput,
  IAviatorSessionMap,
} from '@hit-game/shared/types';

import { http } from '../lib/http';

export const aviatorService = {
  /**
   * Trạng thái MỌI tài khoản đang chạy, một lần hỏi.
   *
   * `_silent`: sảnh hỏi lại mỗi vài giây, một nhịp hỏng không đáng nổi toast —
   * cùng cách `groupService.sessions` đang làm.
   */
  sessions(): Promise<{ sessions: IAviatorSessionMap }> {
    return http.get('/aviator/sessions', { _silent: true });
  },

  /** Cấu hình của nhiều tài khoản một lượt — thẻ ở sảnh vẽ cả danh sách cùng lúc. */
  profiles(accountIds: string[]): Promise<{ profiles: IAviatorProfile[] }> {
    return http.get('/aviator/profiles', {
      params: { accountIds: accountIds.join(',') },
      _silent: true,
    });
  },

  save(accountId: string, input: IAviatorProfileInput): Promise<{ profile: IAviatorProfile }> {
    return http.put(`/aviator/${accountId}`, input);
  },

  remove(accountId: string): Promise<unknown> {
    return http.delete(`/aviator/${accountId}`);
  },

  start(accountId: string): Promise<unknown> {
    return http.post(`/aviator/${accountId}/start`);
  },

  stop(accountId: string): Promise<{ deferred: boolean; sessionId: number | null }> {
    return http.post(`/aviator/${accountId}/stop`);
  },
};
